module.exports = __webpack_public_path__ + "static/007093-7348415049635747bcc4cdb0a13c0434.jpg";